import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { CloneService } from 'src/app/services/clone.service';
import { DoorWidthReductionValue, DoorWidthReduction } from 'src/app/models/DoorWidthReduction.model';
import { DoorWidthReal } from 'src/app/models/DoorWidthReal.model';
import { Standback } from 'src/app/models/Standback.model';
import { GridData } from 'src/app/matrix-component/grid-list/gridData.model';
import { IdValue } from 'src/app/matrix-component/grid-list/idvalue.model';

@Component({
  selector: 'app-door-width-reduction',
  templateUrl: './door-width-reduction.component.html',
  styleUrls: ['./door-width-reduction.component.scss']
})
export class DoorWidthReductionComponent implements OnInit {

  constructor(private _formBuilder: FormBuilder,private cloneService:CloneService) { }


  ngOnInit() {
    this.form = this.parentForm;
    this.form.addControl('doorWidthReduction', this._formBuilder.array([]));
    this.form.setControl('doorWidthReduction', this.asFormGroup(this.data));
    this.lascCtrl = this.form.get('doorWidthReduction');
    this.lascCtrl= this.lascCtrl.get('values');
    this.data.values =  this.lascCtrl.value as DoorWidthReductionValue[];
    this.gridData=this.ConvertData();
  }
  asFormGroup(o: DoorWidthReduction): FormGroup {
    const fg = new FormGroup({
      id: new FormControl(o.id, Validators.required),
      regionId: new FormControl(o.regionId, Validators.required),
      values: new FormControl(o.values, Validators.required)
    });
    return fg;
  }
  @Input('form') parentForm: FormGroup;
  @Input('data') data: DoorWidthReduction;
  @Input('colHeaders') colHeaders: Standback[];
  @Input('rowHeaders') rowHeaders: DoorWidthReal[];
  @Input('isEditable') isEditable: boolean;
  gridData: GridData=new GridData();
  form: FormGroup;
  lascCtrl;

  ConvertData(): GridData {
    let rowHeaders: IdValue[] = [];
    for (let i = 0; i < this.rowHeaders.length; i++) {
      const headerEntry = this.rowHeaders[i];
      rowHeaders.push(new IdValue(headerEntry.id,headerEntry.name));
    }

    let colHeaders: IdValue[] = [];
    for (let i = 0; i < this.colHeaders.length; i++) {
      const headerEntry = this.colHeaders[i];
      colHeaders.push(new IdValue(headerEntry.id,headerEntry.name));
    }
    let grid: GridData = new GridData();
    grid.colHeaders = colHeaders;
    grid.rowHeaders = rowHeaders;
    grid.matrix = this.data.values;
    grid.colProp = 'standbackId';
    grid.rowProp = 'doorWidthRealId';
    grid.switchColWithRow = false;
    return grid;
  }
  normalizeAgeGenderAndLuggageTypeIds(temp: DoorWidthReductionValue[]) {
    this.data.values=temp;
  }
  save()
  {
    let clonedGridData = this.cloneService.deepClone(this.gridData.matrix) as DoorWidthReductionValue[];
    this.normalizeAgeGenderAndLuggageTypeIds(clonedGridData);
    if(this.lascCtrl !== null)
    {
      this.lascCtrl.patchValue(this.data.values);
    }
  }
}
